import React from "react";
import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { ArrowRight } from "lucide-react";

export default function Flavors({ products = [], onOrder }) {
  return (
    <section id="smaken" className="relative bg-gradient-to-b from-sfc-night to-[#120726] px-5 py-28 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
            <div>
              <span className="text-xs font-semibold uppercase tracking-[0.3em] text-sfc-yellow">Onze smaken</span>
              <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-white sm:text-5xl lg:text-6xl">
                Drie smaken, <br className="hidden sm:block" />oneindig veel beleving.
              </h2>
            </div>
            <p className="max-w-sm text-sm text-white/60">
              Elk drankje is ontworpen om te verrassen. Beschikbaar per krat, klaar voor uw kaart.
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid gap-7 md:grid-cols-3">
          {products.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.12}>
              <motion.article
                data-testid={`flavor-card-${p.slug}`}
                whileHover={{ y: -10 }}
                transition={{ type: "spring", stiffness: 260, damping: 20 }}
                className="group relative flex h-full flex-col overflow-hidden rounded-[2rem] border border-white/10 bg-white/[0.03]"
                style={{ boxShadow: `0 30px 60px -30px ${p.accent_color}55` }}
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={p.image_url}
                    alt={p.name}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0" style={{ background: `linear-gradient(to top, ${p.accent_color}dd, transparent 60%)` }} />
                  <span className="absolute right-4 top-4 rounded-full bg-black/40 px-3 py-1 text-xs font-medium text-white backdrop-blur">
                    {p.stock_status === "in_stock" ? "Op voorraad" : "Beperkt"}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="font-display text-2xl font-semibold text-white" style={{ color: p.accent_color }}>{p.name}</h3>
                  <p className="mt-2 text-sm text-white/70">{p.short_description}</p>
                  <p className="mt-3 text-xs uppercase tracking-wide text-white/45">{p.flavor_profile}</p>
                  <div className="mt-auto flex items-center justify-between pt-6">
                    <div>
                      <p className="font-display text-xl text-white">€{p.price_ex_vat?.toFixed(2)}</p>
                      <p className="text-xs text-white/50">excl. btw · {p.unit_name}</p>
                    </div>
                    <button
                      data-testid={`flavor-order-${p.slug}`}
                      onClick={onOrder}
                      className="flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-white/10"
                    >
                      Bestellen <ArrowRight size={16} />
                    </button>
                  </div>
                </div>
              </motion.article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
